 <template>
  <div :class="fileList.length<1? '' : 'hide'">
    <el-upload
      action=""
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :http-request="upload"
      :limit="1"
      :file-list="fileList"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" close="dialogIndex" append-to-body>
      <img class="img dialogIndex" width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { uploadAdmin } from '../../../../api/businessCenter'
export default {
  components: {},
  props: {
    imageShow: {
      type: String
    }
  },
  watch: {
    imageShow(val) {
      //console.log(val)
      this.fileList = []
      if (val) {
        this.fileList.push({
          name: val,
          url: val
        })
      }
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: []
    }
  },

  computed: {},

  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    async upload(params) {
      // console.log(params.file)
      const form = new FormData()
      form.append('files', params.file)

      const { data: res } = await uploadAdmin(form)
      console.log(res)
      this.$emit('uploadOneImgShow', res.data.fileLook[0])
    },
    handleRemove(file, fileList) {
      // console.log(file)
      // console.log(fileList)
      this.$emit('uploadOneImgShow', null)
    }
  },

  created() {
    this.dialogImageUrl = this.imageShow
  },

  mounted() {}
}
</script>
<style scoped lang="less">
/deep/.el-upload--picture-card {
  width: 56px;
  height: 56px;
  background-color: #dcdee0;
  border-radius: 4px;
  border: none;
  // text-align: center;
  line-height: 56px;
  // font-size: 14px;
  // color: #4e93fb;
  display: inline-block;
}
/deep/.el-upload-list__item {
  width: 56px;
  height: 56px;
  border: none;
}
/deep/.el-dialog {
  width: 500px;
  height: 500px !important;
}
/deep/.el-dialog__body {
  width: 500px;
  height: 500px !important;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.el-dialog__header {
  padding: 0;
}
.img {
  width: 450px;
  height: 450px;
}
/deep/ .el-upload-list__item.is-ready {
  display: none;
}
/deep/.el-icon-plus {
  font-size: 7px;
  color: #fff;
}
.hide ::v-deep .el-upload--picture-card {
    display: none;
  }
</style>
